<template lang="pug">
    div
        button.change-button(
          :disabled="disabled || loading"
          @click="handleShowModal"
          @hide="hideModal()"
        )
          b-spinner(v-if="loading" small)
          span {{ loading ? 'Procesando...' : 'Entregar equipo al cliente' }}
        SamtekModal(
          v-model="show"
          title="Entregar equipo al cliente"
          confirmText="Confirmar entrega"
          cancelText="Cancelar"
          :loading="loading"
          @confirm="confirm"
          @cancel="hideModal"
        )
          p.mb-3 Ingrese los datos de despacho para entregar el equipo al cliente.
          b-form-group.input-label(label="Tipo de despacho" label-for="input-tipo-despacho")
            b-form-select(
              id="input-tipo-despacho"
              v-model="tipo_despacho"
              :options="tipoDespachoOptions"
              :state="$v.$dirty ? !$v.tipo_despacho.$invalid : null")
            .errors(v-if="$v.$dirty")
              b-form-invalid-feedback(:state="$v.tipo_despacho.required") Campo requerido
          b-form-group(
            label="N° de guía de despacho o N° de factura"
            label-for="input-guia-despacho"
            v-if="tipo_despacho"
          )
            b-input(
              id="input-guia-despacho"
              v-model="numero_guia_despacho"
              :state="$v.$dirty ? !$v.numero_guia_despacho.$invalid : null")
            .errors(v-if="$v.$dirty")
              b-form-invalid-feedback(:state="$v.numero_guia_despacho.required") Campo requerido
          div(v-if="isTipoDespachoEnvio")
            b-form-group(label="N° de courier" label-for="input-courier-num")
              b-input(
                v-model="numero_courrier"
                id="input-courier-num"
                :state="$v.$dirty ? !$v.numero_courrier.$invalid : null")
              .errors(v-if="$v.numero_courrier.$dirty")
                b-form-invalid-feedback(:state="$v.numero_courrier.required") Campo requerido
            b-form-group(label="Empresa de Courier" label-for="input-courier")
              b-form-select(
                id="input-courier"
                :options="optionsCourier"
                v-model="courier"
                :state="$v.$dirty ? !$v.courier.$invalid : null")
              .errors(v-if="$v.courier.$dirty")
                b-form-invalid-feedback(:state="$v.courier.required") Campo requerido
    </template>
    
    <script>
    import { requiredIf } from 'vuelidate/lib/validators'
    import { mapActions, mapGetters } from 'vuex'
    import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
    import SamtekModal from '@/components/Common/SamtekModal.vue'

    export default {
      components: { SamtekModal },
      name: 'ActionEntregarEquipoCliente',
      mixins: [LoadingButtonMixin],
      props: ['ot', 'disabled'],

      validations: {
        tipo_despacho: {
          required: requiredIf(function () { return true }),
        },
        numero_guia_despacho: {
          required: requiredIf(function () { return this.tipo_despacho }),
        },
        numero_courrier: {
          required: requiredIf(function () { return this.isTipoDespachoEnvio }),
        },
        courier: {
          required: requiredIf(function () { return this.isTipoDespachoEnvio }),
        },
      },
      
      data() {
        return {
          show: false,
          tipo_despacho: null,
          numero_guia_despacho: null,
          numero_courrier: null,
          courier: null,
        }
      },
      computed: {
        ...mapGetters('OTStore', ['couriers']),
        tipoDespachoOptions() {
          return [
            { value: null, text: 'Seleccionar...' },
            { value: 3, text: 'Retiro por cliente' },
            { value: 4, text: 'Envío' },
            { value: 7, text: 'Coordinado por cliente' },
          ]
        },
        optionsCourier() {
          return [
            { value: null, text: 'Seleccione...' },
            ...this.couriers.map((c) => ({ value: c.id, text: c.nombre })),
          ]
        },
        isTipoDespachoEnvio() {
          return this.tipo_despacho === 4 || this.tipo_despacho === 7
        },
      },
      methods: {
        ...mapActions('OT', ['rechazarOT']),
        ...mapActions('OTStore', ['getCourier']),

        handleShowModal() {
          this.getCourier()
          const despachos = { RETIRO: 3, ENVIO: 4, COORD_CLIENTE: 7, null: null }
          this.tipo_despacho = despachos[this.ot?.despacho || this.ot?.sucursal?.despacho]
          this.show = true
        },
        
        hideModal() {
          this.show = false
        },

        async confirm() {
          if (this.$v.$invalid) {
            this.$v.$touch()
            return
          }
          try {
            await this.executeWithLoading(async () => {
              const data = {
                orden_trabajo: this.ot.ot,
                numero_guia_despacho: this.numero_guia_despacho,
                numero_courrier: this.numero_courrier,
                courier: this.courier,
              }
              const response = await this.rechazarOT(data)
              if (response.status === 200) {
                this.hideModal()
                this.$bvToast.toast('Equipo entregado al cliente y OT cerrada', {
                  variant: 'success',
                })
                this.$emit('changed')
              } else {
                const msg = response.data?.error || 'Error al entregar equipo'
                this.$bvToast.toast(msg, { variant: 'danger' })
              }
            })
          } catch (error) {
            console.error('Error al entregar equipo:', error)
            this.$bvToast.toast('Error al entregar equipo al cliente', {
              variant: 'danger',
            })
          }
        },

      }
    }
    </script>
